<template>
  <div>
    <div class="container">
      <div class="row margin-top">
        <div class="col-8 offset-2">
          <div class="row medium-font">
            <div v-if="claim === null" class="col text-center">
              <p>
                <strong>
                  Please wait...
                </strong>
              </p>
            </div>
            <div v-else>
              <div v-if="claim.settlement_customer_approved" class="col text-center">
                <div v-if="noteSent">
                  <p>
                    <strong>
                      You have accepted settlement amount of ${{ claim.settlement_amount }} for move {{ claim.ref_id }}.
                      Customer care agent will get in touch shortly so that your complaint can be resolved.
                    </strong>
                  </p>
                </div>
                <div v-else>
                  <p>
                    Let us know if you wish to receive the refund via check or on credit card and confirm that the card used for the payment of the service is still valid and active.
                  </p>
                  <div class="col pr-1 pb-3">
                    <div class="select-wrap">
                      <label>Note</label>
                      <textarea v-model="note"
                                cols="80"
                                rows="5"
                                class="form-control select-wrap-textarea"
                      />
                    </div>
                  </div>
                  <div>
                    <button type="button" class="btn btn-primary ld-ext-right"
                            @click="sendNote"
                    >
                      Send
                    </button>
                  </div>
                </div>
              </div>
              <div v-if="!claim.settlement_customer_approved" class="col text-center">
                <p>
                  <strong>
                    You have rejected settlement amount of ${{ claim.settlement_amount }} for move {{ claim.ref_id }}.
                    Customer care agent will get in touch shortly so that your complaint can be resolved.
                  </strong>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-8 offset-2">
          <div class="row">
            <div class="col text-right">
              <a href="#" class="thick-font">Need help?</a><br />
              <p class="info-text">Visit our knowledge base</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data: () => ({
    claim: null,
    note: '',
    noteSent: false,
  }),
  mounted() {
    this.sendCode();
  },
  methods: {
    sendCode() {
      axios
        .post('claims/confirm', { hash: this.$route.params.id })
        .then(res => {
          this.claim = res.data.data;
        })
        .catch(err => {
          this.claim = err;
        });
    },
    sendNote() {
      axios
        .post('claims/confirm', {
          hash: this.$route.params.id,
          note: this.note,
        })
        .then(res => {
          this.claim = res.data.data;
          this.noteSent = true;
        })
        .catch(err => {
          this.claim = err;
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/claims/ClaimConfirm.vue